import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FortifyOidcService } from 'src/app/services/oidc/fortify-oidc.service';
import { ContentfulService } from 'src/app/services/contentful/contentful.service';
import { AppState } from 'src/app/models/interfaces';
import * as AllActions from 'src/app/store/actions/index';
//
// ngrx / rxjs
//
import { Store } from '@ngrx/store';
import { SharedService } from 'src/app/services/shared/shared.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/internal/operators/take';



@Component({
  selector: 'app-fortify-logout',
  templateUrl: './fortify-logout.component.html',
  styleUrls: ['./fortify-logout.component.scss']
})
export class FortifyLogoutComponent implements OnInit {
  projectLayout : boolean = false;
  showProgressBar : boolean = true;
  img : string;
  imgId : string;
  imgLabel: string;
  imgLink : string;
  imageURLAsset: string;


  constructor(
    private router : Router,
    private store: Store<AppState>,
    private oidcFortify : FortifyOidcService,
    private contentful : ContentfulService,
    private shared : SharedService,
    private storage : StorageService
  ) { }

  ngOnInit() {
    //
    // Subscribe to the AD and progressbar.
    //
    this.contentful.getAd().subscribe(data => {
      if ( data != (null || undefined)) {
        this.img = data.items[0].fields.image;
        this.imgId = data.items[0].fields.id;
        this.imgLabel = data.items[0].fields.label;
        this.imgLink = data.items[0].fields.link;
        this.imageURLAsset = data.items[0].fields.asset.fields.file.url;
      }
    })
    this.shared.getProgressBar().subscribe(data => {
      if ( data != (null || undefined)) {
        this.showProgressBar = data;
      }
    })

    if(this.storage.getItem('tpa-login') == "true"){
      //
      // Set Logout Flag for the re-connection.
      //
      this.storage.setItem('logout-fortify','true');
      //
      // Re-establish connection. will reroute to fortify-direct
      //
      this.store.dispatch(AllActions.preLogin({ username: '' }));
    }else{
      this.storage.remove('logout-fortify');
      this.router.navigate(['login']);
    }
  }



  logoutFortify() {
    this.store.dispatch(AllActions.logoutFortify());
  }




}
